import React from 'react';
import { FormPanel, FormTextField, FormSelect } from '@eas/common-web';
import { FormattedMessage } from 'react-intl';
import {
  useNonStandardStateLevels,
  useSeverity,
} from './non-standard-states-api';

export function Fields() {
  const levelSource = useNonStandardStateLevels();
  const severity = useSeverity();

  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="TAPIS__NON_STANDARD_STATE__DETAIL__PANEL_TITLE__BASIC_INFO"
            defaultMessage="Základní informace"
          />
        }
      >
        <FormTextField
          name="name"
          label={
            <FormattedMessage
              id="TAPIS__NON_STANDARD_STATE__DETAIL__FIELD_LABEL__ID"
              defaultMessage="Název"
            />
          }
          required
        />
        <FormTextField
          name="description"
          label={
            <FormattedMessage
              id="TAPIS__NON_STANDARD_STATE__DETAIL__FIELD_LABEL__DESCRIPTION"
              defaultMessage="Popis"
            />
          }
        />
        <FormTextField
          name="code"
          label={
            <FormattedMessage
              id="TAPIS__NON_STANDARD_STATE__DETAIL__FIELD_LABEL__CODE"
              defaultMessage="Kód"
            />
          }
          disabled
        />
        <FormSelect
          name="severity"
          label={
            <FormattedMessage
              id="TAPIS__NON_STANDARD_STATE__DETAIL__FIELD_LABEL__SEVERITY"
              defaultMessage="Vážnost"
            />
          }
          source={severity}
          valueIsId={true}
          disabled
        />
        <FormSelect
          name="level"
          label={
            <FormattedMessage
              id="TAPIS__NON_STANDARD_STATE__DETAIL__FIELD_LABEL__LEVEL"
              defaultMessage="Úroveň"
            />
          }
          source={levelSource}
          valueIsId={true}
          disabled
        />
      </FormPanel>
    </>
  );
}
